/*---------------------------------------------------------------------------
 The following JavaScript functions control Tender Admin client side functions
-----------------------------------------------------------------------------*/

var TECL_TenderAdmin = {

  // Sve the current setting
  SaveSupplierSelections: function() {
    if (TECL_Master.AddLock("TECL_TenderAdmin.SaveSupplierSelections")) {
      $("#SaveErrorText").addClass("hidden");

      // Get the ids of the selected suppliers
      var selectedSupplierIds = [];
      $("[name='supplierSelectCntrl']").each(function() {
        if ($(this).is(":checked")) {
          var supplierId = $(this).val();
          selectedSupplierIds.push(supplierId);
        }
      });

      var primaryKeyId = $("#PrimaryKeyId").val();

      var isTender = true;
      var isTenderValue = $("#IsTender").val();
      if (isTenderValue && isTenderValue == "0") {
        isTender = false;
      }

      var commission = $("#commissionRate").val();

      $.ajax({
        url: baseSiteUrl + "umbraco/Surface/TenderAdminSurface/SaveSelectedSuppliers",
        type: "POST",
        data: {
          primaryKeyId: primaryKeyId,
          selectedSupplierIds: selectedSupplierIds,
          isTender: isTender,
          commissionRate: commission
        },
        error: function(exc) {
          TECL_Master.ClearLock("TECL_TenderAdmin.SaveSupplierSelections");
          TECL_Master.ShowErrorDialog();
        },
        success: function(saveData) {
          TECL_Master.ClearLock("TECL_TenderAdmin.SaveSupplierSelections");
          if (saveData) {
            if (saveData.Saved) {
              TECL_Master.DisplayNoticeDlg("The supplier changes have been saved.");
            } else {
              TECL_Master.ShowErrorDialog(saveData.ErrorText);
            }
          } else {
            TECL_Master.ShowErrorDialog("Failed to save the changes");
          }
        }
      });
    }
  },

  // Change the toggle state 
  SelectAllSuppliers: function() {

    if (TECL_Master.AddLock("TECL_TenderAdmin.SelectAllSuppliers")) {

      var allSelected = true;

      $("[name='supplierListItem']").each(function() {
        if (!$(this).hasClass("hidden")) {
          var checkbox = $(this).find("[name='supplierSelectCntrl']");

          var selected = checkbox.is(":checked");
          if (!selected) {
            allSelected = false;
          }
        }
      });

      var checked = !allSelected;

      $("[name='supplierListItem']").each(function() {
        if (!$(this).hasClass("hidden")) {
          var checkbox = $(this).find("[name='supplierSelectCntrl']");
          checkbox.prop('checked', checked);
        }
      });

      TECL_Master.ClearLock("TECL_TenderAdmin.SelectAllSuppliers");
    }
  },

  // Filter the list of suppliers
  FilterSupplierSelections: function(updateCssClasses) {
    var id = $("#PrimaryKeyId").val();
    var isTender = true;
    var isTenderValue = $("#IsTender").val();
    if (!isTenderValue || isTenderValue == "0") {
      isTender = false;
    }
    var regionValues = $("#msRegionFilter").data("kendoMultiSelect").value();
    var productCatValues = $("#msProductCategoryFilter").data("kendoMultiSelect").value();

    $.ajax({
      url: baseSiteUrl + "umbraco/Surface/TenderAdminSurface/FilterSuppliers",
      type: "POST",
      data: {
        regionValues: regionValues,
        productCatValues: productCatValues,
        activityId: id,
        isTender: isTender
      },
      error: function(exc) {
        TECL_Master.ShowErrorDialog();
      },
      success: function(displaySupplierInfos) {
        if (displaySupplierInfos) {

          $("#supplierList").find("[name=supplierListItem]").each(function() {
            var display = false;

            var index;
            for (index = 0; index < displaySupplierInfos.length; ++index) {
              var displaySupplierInfo = displaySupplierInfos[index];
              var currentSupplierId = $(this).attr("data-supplierid");

              if (displaySupplierInfo.SupplierId == currentSupplierId) {
                display = displaySupplierInfo.Display;

                if (updateCssClasses) {
                  $(this).addClass(displaySupplierInfo.CssClass);
                }
                break;
              }
            }

            if (display) {
              $(this).removeClass("hidden");
            } else {
              $(this).addClass("hidden");
            }
          });
        } else {
          TECL_Master.ShowErrorDialog();
        }
      }
    });
  },

  // Display Basic Details Dialog
  DisplayBasicDetailsDialog: function(supplierTenderId) {

    if (supplierTenderId && TECL_Master.AddLock("TECL_TenderAdmin.DisplayBasicDetailsDialog")) {
      TECL_TenderGeneral.DisplayPleaseWaitDlg();

      $.ajax({
        url: baseSiteUrl + "umbraco/Surface/TenderAdminSurface/DisplayBasicDetailsDialog",
        type: "POST",
        data: {
          supplierTenderId: supplierTenderId
        },
        error: function(exc) {
          TECL_Master.ClearLock("TECL_TenderAdmin.DisplayBasicDetailsDialog");
          TECL_TenderGeneral.HidePleaseWaitDlg();
          TECL_Master.ShowErrorDialog();
        },
        success: function(viewHtml) {
          TECL_Master.ClearLock("TECL_TenderAdmin.DisplayBasicDetailsDialog");
          TECL_TenderGeneral.HidePleaseWaitDlg();
          if (viewHtml) {
            $("#basicDetailsDlgDiv").html(viewHtml);
            $("#basicDetailsDlg").modal("show");
          } else {
            TECL_Master.ShowErrorDialog();
          }
        }
      });
    }
  },

  // Display School Invoice Dialog
  DisplaySchoolInvoiceDialog: function(supplierTenderId) {

    if (supplierTenderId && TECL_Master.AddLock("TECL_TenderAdmin.DisplaySchoolInvoiceDialog")) {
      TECL_TenderGeneral.DisplayPleaseWaitDlg();

      $.ajax({
        url: baseSiteUrl + "umbraco/Surface/TenderAdminSurface/DisplaySchoolInvoiceDialog",
        type: "POST",
        data: {
          supplierTenderId: supplierTenderId
        },
        error: function(exc) {
          TECL_Master.ClearLock("TECL_TenderAdmin.DisplaySchoolInvoiceDialog");
          TECL_TenderGeneral.HidePleaseWaitDlg();
          TECL_Master.ShowErrorDialog();
        },
        success: function(viewHtml) {
          TECL_Master.ClearLock("TECL_TenderAdmin.DisplaySchoolInvoiceDialog");
          TECL_TenderGeneral.HidePleaseWaitDlg();
          if (viewHtml) {
            $("#schoolInvoiceDlgDiv").html(viewHtml);
            $("#schoolInvoiceDlg").modal("show");
          } else {
            TECL_Master.ShowErrorDialog();
          }
        }
      });
    }
  },

  // Display Edco Invoice Dialog
  DisplayEdcoInvoiceDialog: function(parentTenderId, supplierTenderId) {

    if (supplierTenderId && TECL_Master.AddLock("TECL_TenderAdmin.DisplayEdcoInvoiceDialog")) {
      TECL_TenderGeneral.DisplayPleaseWaitDlg();

      $.ajax({
        url: baseSiteUrl + "umbraco/Surface/TenderAdminSurface/DisplayEdcoInvoiceDialog",
        type: "POST",
        data: {
          parentTenderId: parentTenderId,
          supplierTenderId: supplierTenderId
        },
        error: function(exc) {
          TECL_Master.ClearLock("TECL_TenderAdmin.DisplayEdcoInvoiceDialog");
          TECL_TenderGeneral.HidePleaseWaitDlg();
          TECL_Master.ShowErrorDialog();
        },
        success: function(viewHtml) {
          TECL_Master.ClearLock("TECL_TenderAdmin.DisplayEdcoInvoiceDialog");
          TECL_TenderGeneral.HidePleaseWaitDlg();
          if (viewHtml) {
            $("#edcoInvoiceDlgDiv").html(viewHtml);
            $("#edcoInvoiceDlg").modal("show");
          } else {
            TECL_Master.ShowErrorDialog();
          }
        }
      });
    }
  },

  // Save Edco Notes on Supplier
  SaveEdcoNotesOnSupplier: function(parentTenderId, supplierTenderId) {
    var edcoNotes = $("#edcoInvoiceDlg").find("[name=edCoNotes]").val();

    if (parentTenderId && supplierTenderId && TECL_Master.AddLock("TECL_TenderAdmin.SaveSupplierInvoiceNotes")) {
      $.ajax({
        url: baseSiteUrl + "umbraco/Surface/TenderAdminSurface/SaveEdcoNotesOnSupplier",
        type: "POST",
        data: {
          parentTenderId: parentTenderId,
          supplierTenderId: supplierTenderId,
          notes: edcoNotes
        },
        error: function(exc) {
          TECL_Master.ClearLock("TECL_TenderAdmin.SaveSupplierInvoiceNotes");
          TECL_Master.ShowErrorDialog();
        },
        success: function(result) {
          TECL_Master.ClearLock("TECL_TenderAdmin.SaveSupplierInvoiceNotes");
          if (result) {
            TECL_Master.DisplayNoticeDlg("Notes saved");
          } else {
            TECL_Master.ShowErrorDialog();
          }
        }
      });
    }
  },

  // Save Commission Invoice Data
  SaveCommissionInvoiceData: function(parentTenderId, supplierTenderId) {
    var $dialog = $("#edcoInvoiceDlg");

    if (supplierTenderId && $dialog && TECL_Master.AddLock("TECL_TenderAdmin.SaveCommissionInvoiceData")) {
      var notes = $dialog.find("[name=edCoNotes]").val();

      $.ajax({
        url: baseSiteUrl + "umbraco/Surface/TenderAdminSurface/SaveCommissionInvoiceData",
        type: "POST",
        data: {
          parentTenderId: parentTenderId,
          SupplierTenderId: supplierTenderId,
          notes: notes
        },
        error: function(exc) {
          TECL_Master.ClearLock("TECL_TenderAdmin.SaveCommissionInvoiceData");
          TECL_Master.ShowErrorDialog();
        },
        success: function(result) {
          TECL_Master.ClearLock("TECL_TenderAdmin.SaveCommissionInvoiceData");
          if (result) {
            $("#edcoInvoiceDlg").modal("hide");
            TECL_TenderGeneral.DisplayMessageDlg("Status updated to archived.");
          } else {
            TECL_Master.ShowErrorDialog();
          }
        }
      });
    }
  }

};